import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import toast from './plugins/toastification'
import VueLoading from './plugins/loading'

Vue.config.productionTip = false

router.afterEach((to) => {
    const version = 'MYSCH v5 - ';
    const defaultTitle = 'Students Results Manager & More';
    document.title = version + (to.meta.title || defaultTitle);
});

new Vue({
  router,
  store,
  vuetify,
  toast,
  VueLoading,
  beforeCreate() {
    this.$store.commit('initializeStore')
  },
  render: h => h(App)
}).$mount('#app')
